// amount [1, 2, 5]
// word ['вакансия', 'вакансии', 'вакансий']

export default function numberPluralization(count) {
  if (count === 0) {
    return 2;
  }

  const teen = count > 10 && count < 20;
  const endsWithOne = count % 10 === 1;

  if (!teen && endsWithOne) {
    return 0;
  }

  if (!teen && count % 10 >= 2 && count % 10 <= 4) {
    return 1;
  }

  return 2;
}
